var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "150 200 1300 1200",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M772.44 1295.02c-107.13,0 -156.91,-15.6 -243.19,-77.99 -54.92,70.2 -227.77,124.81 -235.38,31.2 0,-70.14 -15.84,-129.23 -33.31,-194.26 -21.38,-79.69 -45.16,-168.33 -45.16,-297.16 0,-307.17 253.55,-538.24 554.22,-538.24 300.58,0 536.3,242.3 536.3,541.23 0,298.89 -243.23,535.23 -533.49,535.23l0.01 -0.01zm4.34 -810.86c-146.28,-7.62 -260.42,93.24 -285.6,251.11 -20.87,130.76 16.11,290.06 47.72,298.07 14.92,3.78 53.1,-26.92 76.62,-50.31 38.73,24.94 83.14,44.28 132.52,46.82 150.2,7.82 283.26,-108.97 291.15,-258.22 7.88,-149.25 -112.21,-279.65 -262.39,-287.47l-0.02 0z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.3cae8af3529c028db5d94d7f4fc45525.svg";
export { ForwardRef as ReactComponent };